module.exports = __webpack_public_path__ + "img/Pic_Text_IONE.8dab68f9.png";